import { atom, useAtom } from "jotai";

const isInDesignLayerContetAtom = atom(false);

export function useIsInDesignLayerContext() {
    const [isInDesignLayerContext, setIsInDesignLayerContext] = useAtom(
        isInDesignLayerContetAtom,
    );

    return { isInDesignLayerContext, setIsInDesignLayerContext };
}
